import { action } from 'mobx';
import { taskManagerApi } from 'src/services/apiServices';
import { AsyncOperationWithStatus } from 'src/utils/mobx/AsyncOperationWithStatus';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { BasicStoreApi } from 'src/utils/mobx/BasicStore/BasicStore.types';
import { RequestHelper } from 'src/utils/RequestHelper';

export class CurrentTaskStoreClass extends BasicStore<Record<string, any>> {
    itemDetailsFormKey = '';
    itemPathKey = 'taskId';

    api: BasicStoreApi<Record<string, any>> = {
        loadItem: (id: string, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                taskManagerApi.getTaskFormVariables(id, options),
            );
        },

        loadItemForm: (key: string, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                taskManagerApi.getTaskForm(key, options),
            );
        },
    };

    claimTaskAction = new AsyncOperationWithStatus(
        (taskId: string, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                taskManagerApi.claim(taskId, options),
            );
        },
    );

    unclaimTaskAction = new AsyncOperationWithStatus(
        (taskId: string, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                taskManagerApi.unclaim(taskId, options),
            );
        },
    );

    submitFormLoader = new AsyncOperationWithStatus(
        (taskId: string, values: Record<string, any>, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                taskManagerApi.submitForm(taskId, values, options),
            );
        },
    );

    @action reset() {
        this.itemLoader.reset();
        this.formLoader.reset();
    }

    @action async claim(id: string) {
        await this.claimTaskAction.call(id);
    }

    @action async unclaim(id: string) {
        await this.unclaimTaskAction.call(id);
    }

    @action submitForm(taskId: string, values: any) {
        return this.submitFormLoader.call(taskId, values);
    }
}

export const CurrentTaskStore = new CurrentTaskStoreClass();
